module.exports = __webpack_public_path__ + "img/slide_3.42151609.jpg";